import React, { useEffect, useState } from 'react';
import { TimePicker as MUITimePicker } from '@mui/x-date-pickers/TimePicker';
import { TextField } from '@mui/material';
import { isValid, parse } from 'date-fns';

import { TimePickerProps } from './types';
import { useDateTimePickerFormatter } from 'src/hooks/useDateTimePickerFormatter';

const TIME_FORMAT = 'HH:mm';

export const TimePicker: React.FC<TimePickerProps> = ({ value, handleTimeChange, isDisabled }) => {
  const parsedValue = parse(value, TIME_FORMAT, new Date());

  const timeValue = isValid(parsedValue) ? parsedValue : null;

  const [selectedTime, setSelectedTime] = useState<Date | null>(timeValue);

  useEffect(() => {
    setSelectedTime(timeValue);
  }, [value]);

  const handleChange = useDateTimePickerFormatter({
    setState: setSelectedTime,
    onChange: handleTimeChange,
    formatPattern: TIME_FORMAT,
  });

  return (
    <MUITimePicker
      inputFormat={TIME_FORMAT}
      value={selectedTime}
      onChange={handleChange}
      ampm={false}
      views={['hours']}
      renderInput={props => (
        <TextField
          {...props}
          fullWidth
          sx={{
            '& .MuiInputBase-root': {
              height: '40px',
              padding: '0px',
            },
          }}
        />
      )}
      disabled={isDisabled}
    />
  );
};
